import React from 'react';
import styled from 'styled-components';

export const PortfolioSection = ({ portfolios }) => {
  return (
    <PortfolioSectionStyled>
      {portfolios.map(item => {
        return (
          <div className='grid-item' key={item.id}>
            <div className='portfolio-content'>
              <h6 style={{ color: 'var(--primary-color)' }}>{item.title}</h6>
              <a href={item.url} target='_blank' rel='noopener noreferrer'>
                Visit: {item.url}
              </a>
              <h3 style={{ marginTop: '1rem', color: 'var(--primary-color)' }}>
                Experience
              </h3>
              <p>{item.text}</p>
            </div>
            <div className='portfolio-video-container'>
              <video
                className='portfolio-video'
                src={item.video}
                autoPlay
                muted
                loop
                playsInline
              />
            </div>
          </div>
        );
      })}
    </PortfolioSectionStyled>
  );
};

const PortfolioSectionStyled = styled.div`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  grid-gap: 2rem;
  @media screen and (max-width: 920px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media screen and (max-width: 670px) {
    grid-template-columns: repeat(1, 1fr);
  }
  .grid-item {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 1rem;
    align-items: start;
    padding: 1rem;
    border: 4px solid var(--border-color);
    transition: all 0.2s ease-in-out;
    &:hover {
      transform: scale(1.05);
      border: 4px solid var(--primary-color);
    }

    .portfolio-video {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
    .portfolio-content {
      padding: 0 1rem;
      width: 100%;
        h6 {
          font-size: 1.5rem;
        }
      },
    }
  }
  @media screen and (max-width: 790px) {
    .grid-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      video {
        width: 100%;
      }

      .portfolio-content {
        margin-left: auto;
        margin-right: auto;
        width: 100%;
      }
    }
  }
`;
